var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('SingleUserBody',{attrs:{"adminKyc":_vm.users.singleUserKyc,"loading":_vm.users.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }